import React, { useEffect } from 'react';
import { ThemeProvider } from '@material-ui/core';

import { useActivation } from '../ActivationContext';
import usePostAuthNavigation from '../hooks/usePostAuthNavigation';
import { usePostAuthRedirectTo } from '../hooks/usePostAuthRedirectTo';
import { ContentContainer, FlexContainer } from './AuthMethodSelection.styles';

import sleepioTheme from '@/themes/sleepioTheme';
import PasswordSavedPanel from '@/pages/SleepioPassword/PasswordSavedPanel';
import { Footer } from '@/pages/Onboarding/components/Footer/Footer';
import { SleepioHeader } from '@/pages/Onboarding/components/Header/SleepioHeader';
import { useAcceptedLanguage } from '@/hooks/useAcceptedLanguage';

/**
 * "You're all set" — the password saved, and the way onward.
 *
 * The hand-off code is minted by the step this button leads to, **after** the password
 * has already saved. That ordering is deliberate: the code lives about thirty seconds
 * and can be used once, so minting it any earlier would expire it while the member was
 * still typing.
 */
const PasswordSavedInner: React.FC = () => {
  useAcceptedLanguage();

  const { dispatch } = useActivation();
  // The button below leads to the step that mints the one-time code and redirects to
  // the app. It needs the deep link, and this screen may be running in a fresh tab.
  const navigatePostAuth = usePostAuthNavigation(usePostAuthRedirectTo());

  useEffect(() => {
    dispatch({ type: 'SET_STEP', step: 'password_saved' });
  }, [dispatch]);

  return (
    <ContentContainer>
      <SleepioHeader />
      <FlexContainer maxWidth="xs">
        <PasswordSavedPanel onContinue={() => navigatePostAuth({ replace: true })} />
      </FlexContainer>
      <Footer />
    </ContentContainer>
  );
};

export const PasswordSaved: React.FC = () => (
  <ThemeProvider theme={sleepioTheme}>
    <PasswordSavedInner />
  </ThemeProvider>
);

export default PasswordSaved;
